<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>推荐官管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search search-compact" @keyup.enter="search">
      <Form :label-width="78" :show-message="false">
        <Row :gutter="12">
          <Col :span="6">
            <FormItem label="老师ID/姓名">
              <Input
                placeholder="支持模糊搜索"
                v-model="queryParam.referrerKeyword"
                clearable
              ></Input>
            </FormItem>
          </Col>
          <Col :span="4">
            <FormItem label="FM" :label-width="30">
              <Select
                v-model.number="queryParam.fmId"
                placeholder="全部"
                clearable
                @on-change="search"
              >
                <Option
                  v-for="item in fmList"
                  :value="item.id"
                  :key="item.id"
                >{{ item.nickname }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="5">
            <FormItem label="HR负责人" :label-width="70">
              <Select
                v-model="queryParam.hrName"
                placeholder="全部"
                clearable
                transfer
                @on-change="search"
              >
                <Option
                  v-for="item in $constant.hrList"
                  :value="item.code"
                  :key="item.code"
                >{{ item.text }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="5">
            <FormItem label="状态" :label-width="44">
              <Select v-model="queryParam.status" placeholder="全部" clearable @on-change="search">
                <Option :value="1">招聘试用期</Option>
                <Option :value="2">招聘转正</Option>
                <Option :value="3">招聘停用</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="4">
            <FormItem label="年月" :label-width="44">
              <Date-picker
                type="month"
                placeholder="选择月份"
                v-model="queryParam.yearMonth"
                format="yyyy-MM"
                @on-change="yearMonthChange"
                clearable
              ></Date-picker>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>

    <div class="btn-container">
      <Row>
        <Button type="primary" :loading="searchLoading" @click="search" icon="search">搜索</Button>
        <Button type="primary" @click="openAddModal" icon="plus">添加推荐官</Button>
        <Button
          type="primary"
          @click="openBatchHrModal"
          icon="person-add"
        >分配HR负责人</Button>
        <Button type="primary" @click="openBackfillModal" icon="ios-calendar">生成历史汇总</Button>
      </Row>
    </div>

    <div class="rank-panel">
      <div class="rank-title">奖励排行榜（{{ queryParam.yearMonth || '本月' }}）</div>
      <Table
        :columns="rankColumns"
        :data="rankList"
        :loading="rankLoading"
        size="small"
        border
      ></Table>
    </div>

    <Modal width="1050" title="添加推荐官" v-model="showAddModal">
      <Form ref="addForm" :label-width="100" :model="addParam" :rules="addRules">
        <FormItem label="推荐官ID" prop="referrerId">
          <InputNumber
            v-model="addParam.referrerId"
            :min="1"
            :precision="0"
            placeholder="请输入推荐官老师ID"
            style="width: 300px"
            @on-change="onReferrerIdChange"
            @on-blur="onReferrerIdBlur"
          ></InputNumber>
        </FormItem>
        <FormItem label="推荐官姓名">
          <Input
            v-model="addParam.referrerName"
            placeholder="留空则自动取老师姓名"
            style="width: 300px"
          ></Input>
        </FormItem>
        <FormItem label="FM">
          <Select
            v-model.number="addParam.fmId"
            placeholder="请选择FM"
            style="width: 300px"
            clearable
            transfer
          >
            <Option
              v-for="item in fmList"
              :value="item.id"
              :key="item.id"
            >{{ item.nickname }}</Option>
          </Select>
        </FormItem>
        <FormItem label="HR负责人">
          <Select
            v-model="addParam.hrName"
            placeholder="请选择HR负责人"
            style="width: 300px"
            clearable
            transfer
          >
            <Option
              v-for="item in $constant.hrList"
              :value="item.code"
              :key="item.code"
            >{{ item.text }}</Option>
          </Select>
        </FormItem>
        <FormItem label="加入日期">
          <DatePicker
            type="date"
            v-model="addParam.joinDate"
            placeholder="请手动选择（默认空）"
            format="yyyy-MM-dd"
            style="width: 300px"
            clearable
            @on-change="onAddJoinDateChange"
          ></DatePicker>
        </FormItem>
        <FormItem label="状态">
          <Select v-model="addParam.status" placeholder="选择状态" style="width: 300px" transfer>
            <Option :value="1">招聘试用期</Option>
            <Option :value="2">招聘转正</Option>
            <Option :value="3">招聘停用</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showAddModal = false">取消</Button>
        <Button type="primary" :loading="loadingAdd" @click="onAdd">保存</Button>
      </div>
    </Modal>

    <Modal width="800" title="推荐官详情" v-model="showDetailModal">
      <div v-if="detailData">
        <Row :gutter="16" style="margin-bottom: 16px">
          <Col :span="8">
            <b>推荐官ID：</b>{{ detailData.referrerId }}
          </Col>
          <Col :span="8">
            <b>姓名：</b>{{ detailData.referrerName }}
          </Col>
          <Col :span="8">
            <b>状态：</b>{{ getStatusText(detailData.status) }}
          </Col>
        </Row>
        <Row :gutter="16" style="margin-bottom: 16px">
          <Col :span="8">
            <b>FM：</b>{{ detailData.fmName || '-' }}
          </Col>
          <Col :span="8">
            <b>HR负责人：</b>{{ detailData.hrName || '-' }}
          </Col>
          <Col :span="8">
            <b>加入日期：</b>{{ detailData.joinDate }}
          </Col>
        </Row>
        <Divider>月度统计数据</Divider>
        <Table :columns="detailColumns" :data="monthlyStats" size="small" border></Table>
      </div>
      <div slot="footer">
        <Button type="text" @click="showDetailModal = false">关闭</Button>
      </div>
    </Modal>

    <Modal width="400" title="分配HR负责人" v-model="showHrModal">
      <Form :label-width="100" :model="hrParam">
        <FormItem label="HR负责人">
          <Select
            v-model="hrParam.hrName"
            placeholder="请选择HR负责人"
            style="width: 200px"
            clearable
            transfer
          >
            <Option
              v-for="item in $constant.hrList"
              :value="item.code"
              :key="item.code"
            >{{ item.text }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showHrModal = false">取消</Button>
        <Button type="primary" :loading="loadingHr" @click="onUpdateHr">保存</Button>
      </div>
    </Modal>

    <Modal width="480" title="生成历史汇总" v-model="showBackfillModal">
      <Form :label-width="90">
        <FormItem label="开始月">
          <Date-picker
            type="month"
            placeholder="选择开始月"
            v-model="backfillParam.startMonth"
            format="yyyy-MM"
            style="width: 240px"
            @on-change="onBackfillStartChange"
          ></Date-picker>
        </FormItem>
        <FormItem label="结束月">
          <Date-picker
            type="month"
            placeholder="选择结束月"
            v-model="backfillParam.endMonth"
            format="yyyy-MM"
            style="width: 240px"
            @on-change="onBackfillEndChange"
          ></Date-picker>
        </FormItem>
        <p style="color:#999;padding-left:90px;line-height:1.5">
          将按起止月幂等写入月汇总表；当月不落表（保持实时）。可用于支撑累计与排行历史。
        </p>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showBackfillModal = false">取消</Button>
        <Button type="primary" :loading="loadingBackfill" @click="onGenerateRewardMonth">生成</Button>
      </div>
    </Modal>

    <List
      ref="dataList"
      :tableColumns="title"
      :reload="reload"
      listUrl="/referrer/info/list"
      :params="queryParam"
      :onLoading="onLoading"
      operator=""
      @on-selection-change="selectionChange"
    ></List>
  </div>
</template>

<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
export default {
  data () {
    return {
      searchLoading: false,
      loadingAdd: false,
      loadingHr: false,
      rankLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      showAddModal: false,
      showDetailModal: false,
      showHrModal: false,
      showBackfillModal: false,
      loadingBackfill: false,
      backfillParam: {
        startMonth: '',
        endMonth: ''
      },
      fmList: [],
      rankList: [],
      selectedIds: [],
      detailData: null,
      monthlyStats: [],
      addParam: {
        referrerId: null,
        referrerName: '',
        fmId: null,
        hrName: '',
        joinDate: '',
        status: 1
      },
      hrParam: {
        referrerIds: [],
        hrName: ''
      },
      queryParam: {
        referrerKeyword: '',
        fmId: null,
        hrName: '',
        status: null,
        yearMonth: ''
      },
      addRules: {
        referrerId: [{ required: true, type: 'number', message: '请输入推荐官ID' }]
      },
      rankColumns: [
        {
          title: '名次',
          width: 80,
          align: 'center',
          render: (h, params) => {
            return h('span', params.index + 1)
          }
        },
        {
          title: '姓名',
          key: 'referrerName',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.referrerName,
              score: row.monthRankScore
            })
          }
        },
        {
          title: '预计奖励($)',
          width: 140,
          align: 'center',
          render: (h, params) => {
            return h('span', this.formatAmount(params.row))
          }
        }
      ],
      detailColumns: [
        { title: '月份', key: 'month', align: 'center' },
        { title: '推荐数', key: 'recommendCount', align: 'center' },
        { title: '审核通过', key: 'approveCount', align: 'center' },
        { title: '审核拒绝', key: 'rejectCount', align: 'center' },
        { title: '开课数', key: 'openClassCount', align: 'center' }
      ],
      title: [
        {
          type: 'selection',
          width: 50,
          fixed: 'left',
          align: 'center',
          className: 'referrer-select-column'
        },
        {
          title: 'ID-姓名',
          width: 180,
          fixed: 'left',
          ellipsis: true,
          render: (h, params) => {
            let name = params.row.referrerName || '-'
            let tid = params.row.referrerId
            let text = tid == null ? name : (tid + '-' + name)
            return h('Poptip', {
              class: 'referrer-name-poptip',
              props: {
                trigger: 'click',
                transfer: true,
                placement: 'bottom-start',
                wordWrap: true
              }
            }, [
              renderTchNameWithScore(h, {
                text: text,
                score: params.row.monthRankScore
              }),
              h('div', {
                slot: 'content',
                style: {
                  maxWidth: '320px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-all',
                  lineHeight: '22px'
                }
              }, text)
            ])
          }
        },
        {
          title: '状态',
          width: 130,
          minWidth: 130,
          fixed: 'left',
          align: 'center',
          className: 'referrer-status-column',
          render: (h, params) => {
            return h('Select', {
              props: {
                value: params.row.status,
                size: 'small',
                transfer: true
              },
              on: {
                'on-change': value => this.updateStatus(params.row, value)
              }
            }, [
              h('Option', { props: { value: 1 } }, '招聘试用期'),
              h('Option', { props: { value: 2 } }, '招聘转正'),
              h('Option', { props: { value: 3 } }, '招聘停用')
            ])
          }
        },
        {
          title: 'FM',
          width: 100,
          key: 'fmName'
        },
        {
          title: 'HR负责人',
          width: 100,
          key: 'hrName'
        },
        {
          title: '加入日期',
          width: 160,
          align: 'center',
          render: (h, params) => {
            return h('DatePicker', {
              props: {
                value: params.row.joinDate,
                type: 'date',
                format: 'yyyy-MM-dd',
                size: 'small',
                transfer: true,
                clearable: false
              },
              on: {
                'on-change': value => this.updateJoinDate(params.row, value)
              }
            })
          }
        },
        {
          title: '奖励期限(月)',
          width: 110,
          align: 'center',
          className: 'referrer-reward-months-column',
          render: (h, params) => {
            let options = []
            for (let i = 1; i <= 12; i++) {
              options.push(h('Option', { props: { value: i } }, String(i)))
            }
            return h('Select', {
              props: {
                value: params.row.rewardMonths,
                size: 'small',
                transfer: true
              },
              on: {
                'on-change': value => this.updateRewardMonths(params.row, value)
              }
            }, options)
          }
        },
        {
          title: '开课日期',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return h('span', this.formatOpenCourseDate(params.row.openCourseTime))
          }
        },
        {
          title: '本月推荐',
          width: 90,
          align: 'center',
          key: 'monthRecommendCount'
        },
        {
          title: '本月审核通过',
          width: 110,
          align: 'center',
          key: 'monthApproveCount'
        },
        {
          title: '本月审核拒绝',
          width: 110,
          align: 'center',
          key: 'monthRejectCount'
        },
        {
          title: '本月开课',
          width: 90,
          align: 'center',
          key: 'monthOpenClassCount'
        },
        {
          title: '累计推荐',
          width: 90,
          align: 'center',
          key: 'totalRecommendCount'
        },
        {
          title: '累计审核通过',
          width: 110,
          align: 'center',
          key: 'totalApproveCount'
        },
        {
          title: '累计审核拒绝',
          width: 110,
          align: 'center',
          key: 'totalRejectCount'
        },
        {
          title: '累计开课',
          width: 90,
          align: 'center',
          key: 'totalOpenClassCount'
        },
        {
          title: '本月预计奖励($)',
          width: 130,
          align: 'center',
          render: (h, params) => {
            return h('span', this.formatAmount({ monthRewardAmount: params.row.monthRewardAmount }))
          }
        },
        {
          title: '累计奖励($)',
          width: 110,
          align: 'center',
          render: (h, params) => {
            return h('span', this.formatAmount({ monthRewardAmount: params.row.totalRewardAmount }))
          }
        },
        {
          title: '是否达到转正条件',
          width: 140,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.reachFormal ? '是' : '否')
          }
        },
        {
          title: '操作',
          width: 80,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: { click: () => this.showDetail(params.row) }
              }, '详情')
            ])
          }
        }
      ]
    }
  },
  mounted () {
    this.loadFmList()
    this.loadRewardRank()
  },
  methods: {
    loadRankMonthScores () {
      const table = this.rankList
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.referrerId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'referrerId', 'monthRankScore', map)
      })
    },

    search () {
      this.reload = new Date().getTime()
      this.loadRewardRank()
    },
        onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.referrerId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'referrerId', 'monthRankScore', map)
      })
    },
    yearMonthChange (value) {
      this.queryParam.yearMonth = value
      this.search()
    },
    getStatusText (status) {
      const map = { 1: '招聘试用期', 2: '招聘转正', 3: '招聘停用' }
      return map[status] || '-'
    },
    formatAmount (row) {
      let value = row ? row.monthRewardAmount : null
      if (value === undefined || value === null) {
        value = row ? row.rewardAmount : null
      }
      if (value === undefined || value === null) {
        value = row ? row.amount : null
      }
      let num = Number(value || 0)
      return isNaN(num) ? '0.00' : num.toFixed(2)
    },
    loadFmList () {
      // 加载FM列表（外教运营）
      this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(res => {
        this.fmList = res.data || []
      })
    },
    loadRewardRank () {
      this.rankLoading = true
      let params = {}
      if (this.queryParam.yearMonth) {
        params.yearMonth = this.queryParam.yearMonth
      }
      this.$http.get('/referrer/info/rewardRank', { params: params }).then(res => {
        this.rankList = res.data || []
        this.loadRankMonthScores()
      }).catch(() => {
        this.rankList = []
      }).finally(() => {
        this.rankLoading = false
      })
    },
    selectionChange (selection) {
      this.selectedIds = selection.map(item => item.referrerId)
    },
    onReferrerIdChange (val) {
      this.addParam.referrerId = val
      this.fillAddByTchId()
    },
    onReferrerIdBlur () {
      this.fillAddByTchId()
    },
    fillAddByTchId () {
      if (!this.addParam.referrerId) {
        return Promise.resolve()
      }
      let tchId = this.addParam.referrerId
      return this.$http.get('/referrer/info/getByTchId', {
        params: { tchId: tchId }
      }).then(res => {
        // 请求返回时 ID 已变则丢弃，避免串数据
        if (this.addParam.referrerId !== tchId) {
          return
        }
        let info = res.data
        if (!info) {
          this.$Message.warning('老师不存在，无法带出信息')
          return
        }
        // 自动带出姓名/FM/HR；加入日期不带（保持空或用户已选手选值）。状态不改
        this.addParam.referrerName = info.referrerName || ''
        this.addParam.fmId = info.fmId || null
        this.addParam.fmName = info.fmName || ''
        this.addParam.hrName = info.hrName || ''
      }).catch(() => {})
    },
    openAddModal () {
      this.addParam = {
        referrerId: null,
        referrerName: '',
        fmId: null,
        hrName: '',
        joinDate: '',
        status: 1
      }
      this.showAddModal = true
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.resetFields()
        }
      })
    },
    onAdd () {
      this.$refs.addForm.validate(valid => {
        if (!valid) return
        this.loadingAdd = true
        // 提交前再带一次姓名/FM/HR；不改动加入日期
        let keptJoin = this.formatJoinDate(this.addParam.joinDate)
        this.fillAddByTchId().then(() => {
          this.addParam.joinDate = keptJoin
          let payload = Object.assign({}, this.addParam)
          if (keptJoin) {
            payload.joinDate = keptJoin
          } else {
            delete payload.joinDate
          }
          return this.$http.post('/referrer/info/add', payload)
        }).then(res => {
          this.$Message.success('添加成功')
          this.showAddModal = false
          this.addParam = {
            referrerId: null,
            referrerName: '',
            fmId: null,
            hrName: '',
            joinDate: '',
            status: 1
          }
          this.search()
        }).finally(() => {
          this.loadingAdd = false
        })
      })
    },
    formatOpenCourseDate (value) {
      if (value == null || value === '') {
        return ''
      }
      let text = String(value).slice(0, 10)
      return /^\d{4}-\d{2}-\d{2}$/.test(text) ? text : ''
    },
    formatJoinDate (value) {
      if (!value) {
        return ''
      }
      if (typeof value === 'string') {
        // DatePicker on-change 已是 yyyy-MM-dd；兼容误传 ISO
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          return value
        }
        let d = new Date(value)
        if (!isNaN(d.getTime())) {
          let y = d.getFullYear()
          let m = ('0' + (d.getMonth() + 1)).slice(-2)
          let day = ('0' + d.getDate()).slice(-2)
          return y + '-' + m + '-' + day
        }
        return value.slice(0, 10)
      }
      if (value instanceof Date && !isNaN(value.getTime())) {
        let y = value.getFullYear()
        let m = ('0' + (value.getMonth() + 1)).slice(-2)
        let day = ('0' + value.getDate()).slice(-2)
        return y + '-' + m + '-' + day
      }
      return ''
    },
    onAddJoinDateChange (value) {
      // iView on-change 给格式化字符串，避免 v-model Date 被 qs 序列化成 ISO Z
      this.addParam.joinDate = value || ''
    },
    updateJoinDate (row, value) {
      let joinDate = this.formatJoinDate(value)
      if (!joinDate || joinDate === row.joinDate) {
        return
      }
      this.$http.post('/referrer/info/update', {
        referrerId: row.referrerId,
        joinDate: joinDate
      }).then(res => {
        this.$Message.success('加入日期已更新')
        this.search()
      }).catch(() => {
        this.search()
      })
    },
    updateRewardMonths (row, value) {
      if (value == null || value === row.rewardMonths) {
        return
      }
      this.$http.post('/referrer/info/update', {
        referrerId: row.referrerId,
        rewardMonths: value
      }).then(res => {
        this.$Message.success('奖励期限已更新')
        this.search()
      }).catch(() => {
        this.search()
      })
    },
    updateStatus (row, value) {
      if (value === row.status) {
        return
      }
      this.$http.post('/referrer/info/update', {
        referrerId: row.referrerId,
        status: value
      }).then(res => {
        this.$Message.success('状态已更新')
        this.search()
      }).catch(() => {
        this.search()
      })
    },
    showDetail (row) {
      this.$http.get('/referrer/info/detail', { params: { referrerId: row.referrerId } }).then(res => {
        this.detailData = res.data
      })
      this.$http.get('/referrer/info/monthlyStats', { params: { referrerId: row.referrerId } }).then(res => {
        this.monthlyStats = res.data || []
      })
      this.showDetailModal = true
    },
    openBackfillModal () {
      this.backfillParam = { startMonth: '', endMonth: '' }
      this.showBackfillModal = true
    },
    onBackfillStartChange (value) {
      this.backfillParam.startMonth = value || ''
    },
    onBackfillEndChange (value) {
      this.backfillParam.endMonth = value || ''
    },
    onGenerateRewardMonth () {
      if (!this.backfillParam.startMonth || !this.backfillParam.endMonth) {
        this.$Message.warning('请选择开始月和结束月')
        return
      }
      this.loadingBackfill = true
      this.$http.post('/referrer/info/generateRewardMonth', {
        startMonth: this.backfillParam.startMonth,
        endMonth: this.backfillParam.endMonth
      }).then(res => {
        let months = res.data
        this.$Message.success('历史汇总已生成，处理月份数：' + (months == null ? 0 : months))
        this.showBackfillModal = false
        this.search()
      }).finally(() => {
        this.loadingBackfill = false
      })
    },
    openBatchHrModal () {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        this.$Message.warning('请选择数据')
        return
      }
      this.hrParam = {
        referrerIds: this.selectedIds.slice(),
        hrName: ''
      }
      this.showHrModal = true
    },
    onUpdateHr () {
      if (!this.hrParam.hrName) {
        this.$Message.warning('请选择HR负责人')
        return
      }
      if (!this.hrParam.referrerIds || this.hrParam.referrerIds.length === 0) {
        this.$Message.warning('请先勾选推荐官')
        return
      }
      let hrName = this.hrParam.hrName
      this.loadingHr = true
      let requests = this.hrParam.referrerIds.map(referrerId => {
        return this.$http.post('/referrer/info/updateHr', {
          referrerId: referrerId,
          hrName: hrName
        })
      })
      Promise.all(requests).then(() => {
        this.$Message.success('分配成功')
        this.showHrModal = false
        this.selectedIds = []
        this.search()
      }).finally(() => {
        this.loadingHr = false
      })
    }
  }
}
</script>

<style lang="less">
.referrer-name-poptip {
  display: block;
  width: 100%;
  max-width: 100%;
  cursor: pointer;
}
.referrer-name-poptip .ivu-poptip-rel {
  display: block;
  width: 100%;
  max-width: 100%;
}
.referrer-name-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style lang="less" scoped>
.list /deep/ .referrer-select-column {
  text-overflow: clip;
}
.list /deep/ .referrer-select-column .ivu-table-cell {
  padding-left: 0;
  padding-right: 0;
  text-overflow: clip;
}
.list /deep/ .referrer-status-column .ivu-table-cell {
  min-width: 130px;
}
.list /deep/ .referrer-reward-months-column .ivu-table-cell {
  min-width: 110px;
}
.btn-container {
  margin-bottom: 16px;
  .ivu-btn {
    margin-right: 8px;
  }
}
.search-compact {
  /deep/ .ivu-form-item {
    margin-bottom: 12px;
  }
  /deep/ .ivu-date-picker {
    width: 100%;
  }
}
.rank-panel {
  margin-bottom: 16px;
  padding: 12px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  background: #fafafa;
}
.rank-title {
  margin-bottom: 8px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// ReferrerList.vue?4fb79c14